/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ branch: NonNullable<unknown> }} Rd_BranchInputs */

const en_rd_branch = /** @type {(inputs: Rd_BranchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`branch ${i?.branch}`)
};

const id_rd_branch = /** @type {(inputs: Rd_BranchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`branch ${i?.branch}`)
};

/**
* | output |
* | --- |
* | "branch {branch}" |
*
* @param {Rd_BranchInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_branch = /** @type {((inputs: Rd_BranchInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_BranchInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_branch(inputs)
	return en_rd_branch(inputs)
});